export interface IAuthResp {
  email: string;
  token: string;
  lastName?: any;
  firstName: string;
  userDetails: UserDetails;
}

interface UserDetails {
  password?: any;
  username: string;
  authorities: Authority[];
  accountNonExpired: boolean;
  accountNonLocked: boolean;
  credentialsNonExpired: boolean;
  enabled: boolean;
}

interface Authority {
  authority: EAuthRole;
}

export enum EAuthRole {
  USER = 'USER',
  SUPER_ADMIN = 'SUPER_ADMIN',
}
